import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { ErrorText } from '../ErrorText';
import { FieldHelpIcon } from '../FieldHelpIcon';
import styles from './Field.module.css';

export type FieldProps = {
  id?: string;
  label: string;
  /** Нейтральная подсказка под полем (не ошибка). */
  hint?: string;
  /** Ошибка валидации — только под полем, стиль предупреждения. */
  error?: string;
  /** Текст для иконки «?» рядом с подписью. */
  labelHelpText?: string;
  children: ReactNode;
  className?: string;
  dataTestId?: string;
};

export function Field({ id, label, hint, error, labelHelpText, children, className, dataTestId }: FieldProps) {
  return (
    <div data-testid={dataTestId} className={cn(styles.root, className)}>
      <div className={styles.labelRow}>
        {labelHelpText ? <FieldHelpIcon text={labelHelpText} className="shrink-0 translate-y-px" /> : null}
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      </div>
      {children}
      {error ? <ErrorText>{error}</ErrorText> : null}
      {hint && !error ? <p className={styles.hint}>{hint}</p> : null}
    </div>
  );
}
